document.addEventListener('DOMContentLoaded', function () {
  const swiper = new Swiper('.swiper', {
    // Optional parameters
    slidesPerView: 1,
    spaceBetween: 20,
    direction: 'horizontal',
    loop: false,

    // Navigation arrows
    navigation: {
      nextEl: '.custom-swiper-button-next',
      prevEl: '.custom-swiper-button-prev',
    },
    breakpoints: {
      767: {
        slidesPerView: 1.2
      }
    }
  });

  const bullets = document.querySelectorAll('.custom-bullet');

  bullets.forEach((el, idx) => {
    el.addEventListener('click', () => {
      swiper.slideTo(idx);
    });
  });

  function updateActiveBullet(activeIndex) {
    bullets.forEach((el, idx) => {
      el.classList.toggle('active', idx === activeIndex);
    });
  }

  swiper.on('slideChange', () => {
    updateActiveBullet(swiper.activeIndex);
    setTimeout(() => {
      centerActiveBullet();
    }, 400);
  });

  updateActiveBullet(swiper.activeIndex);
  centerActiveBullet();

  function centerActiveBullet() {
    const wrapper = document.querySelector('.timeline-steps-nav-wrapper');
    const nav = document.querySelector('.timeline-steps-nav');
    const active = nav.querySelector('.timeline-step-nav-btn.active');
    if (!active || !wrapper) return;

    const wrapperRect = wrapper.getBoundingClientRect();
    const activeRect = active.getBoundingClientRect();
    const currentScroll = wrapper.scrollLeft;

    let offset = activeRect.left - wrapperRect.left - (wrapperRect.width / 2) + (activeRect.width / 2);

    if (active === nav.firstElementChild) {
      wrapper.scrollTo({ left: 0, behavior: 'smooth' });
      return;
    }

    if (active === nav.lastElementChild) {
      wrapper.scrollTo({ left: wrapper.scrollWidth - wrapper.clientWidth, behavior: 'smooth' });
      return;
    }

    let targetScroll = currentScroll + offset;
    if (targetScroll < 0) targetScroll = 0;
    if (targetScroll > wrapper.scrollWidth - wrapper.clientWidth)
      targetScroll = wrapper.scrollWidth - wrapper.clientWidth;

    wrapper.scrollTo({ left: targetScroll, behavior: 'smooth' });
  }
});
